export enum Languages {
  EN = 'en',
  CS = 'cs',
  SK = 'sk',
}

export type TranslationName = {
  language: Languages;
  value: string;
};
